<!-- NOTE: The original component had <app-floating-configurator />. 
    Please ensure AppFloatingConfigurator is added to the imports array in the .ts file and uncommented here if required. -->
<!-- <app-floating-configurator /> -->

<div class="not-found-container flex flex-col items-center justify-center min-h-screen p-6 bg-surface-0 dark:bg-surface-900">
    <div class="max-w-xl w-full text-center p-10 lg:p-16 rounded-xl shadow-2xl bg-white dark:bg-surface-800 transition-all duration-300">

        <!-- Giant, Stylized 404 -->
        <div class="relative mb-8">
            <h1 class="text-[8rem] sm:text-[12rem] font-extrabold leading-none text-primary opacity-20 dark:opacity-30 transition-opacity duration-500"
                style="font-family: 'Inter', sans-serif;">
                404
            </h1>
            <div class="absolute inset-0 flex flex-col items-center justify-center -translate-y-4">
                <i class="pi pi-fw pi-exclamation-triangle text-6xl text-primary mb-3"></i>
                <h2 class="text-3xl sm:text-4xl font-bold text-surface-900 dark:text-surface-0 mb-1">
                    Oops! Page Not Found
                </h2>
            </div>
        </div>
        
        <!-- Description -->
        <p class="text-surface-600 dark:text-surface-300 text-lg mb-8">
            The resource you're looking for might have been removed, had its name changed, or is temporarily unavailable.
        </p>

        <!-- Call to Action -->
        <div class="flex flex-col sm:flex-row gap-4 justify-center">
            <!-- Primary Action: Go Home -->
            <p-button 
                label="Go to Dashboard" 
                icon="pi pi-home" 
                routerLink="/" 
                styleClass="p-button-primary p-button-lg w-full sm:w-auto"
            />
            
            <!-- Secondary Action: Report Issue (Optional/Example) -->
            <p-button 
                label="Contact Support" 
                icon="pi pi-send" 
                severity="secondary" 
                routerLink="/contact" 
                styleClass="p-button-secondary p-button-lg w-full sm:w-auto"
            />
        </div>

        <!-- Decorative Footer Link -->
        <a routerLink="/help" class="block mt-8 text-sm text-primary-500 hover:text-primary-600 dark:hover:text-primary-400 underline transition-colors">
            Still lost? Visit our Help Center
        </a>
    </div>
</div>
